import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const FirmApprovalRoleAssignmentListFilter = (props) => {
  const [form] = Form.useForm();

  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.tenantUserId) {
        conditions.push(`tenantUserId eq ${values.tenantUserId}`);
      }
      if (values.approvalRole) {
        conditions.push(`approvalRoleByte eq ${values.approvalRole}`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  useEffect(() => {
    getApprovalRoles();
    getTenantUsers();
  }, []);

  const getApprovalRoles = () => {
    RequestHandler.get(`/FirmApprovalRoleAssignment/GetApprovalRoles`)
      .then((res) => {
        if (res.success && res.data) {
          setRoles(res.data);
        }
      })
      .catch(() => {});
  };

  const getTenantUsers = () => {
    RequestHandler.get(`/TenantUser?$count=true&$skip=0`)
      .then((res) => {
        if (res?.value) {
          const activeUsers = res.value.filter(
            (x) => x.isActive && !x.isDeleted
          );
          setUsers(activeUsers);
        }
      })
      .catch(() => {});
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    label="Kullanıcı"
                    name="tenantUserId"
                  >
                    <Select
                      placeholder="Kullanıcı seçiniz"
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        (option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {users.map((u) => (
                        <Select.Option key={u.id} value={u.id}>
                          {u.firstName} {u.lastName} ({u.email})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    label="Onay Rolü"
                    name="approvalRole"
                  >
                    <Select placeholder="Onay rolü seçiniz" allowClear>
                      {roles.map((r) => (
                        <Select.Option key={r.id} value={r.id}>
                          {r.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default FirmApprovalRoleAssignmentListFilter;
